// Reviews imported from BigCommerce each carry a copy of the product's stock photo, so the
// Judge.me photo grid and review thumbnails repeat the same product image. Those copies keep
// BigCommerce's file naming (`..._copy__12345__original.jpg`); hide them and keep real
// customer photos. Judge.me renders and paginates client-side, so re-run on DOM changes.
(() => {
  const IMPORTED_IMAGE = /_copy__\d+__original\./i;
  const ITEM_SELECTOR = '.jm-media-grid__item, .jm-media-thumbnail-list__thumbnail';

  const isImported = (item) => {
    const img = item.querySelector('img') || (item.tagName === 'IMG' ? item : null);
    const src = img && (img.currentSrc || img.src || img.dataset.src || '');
    return Boolean(src) && IMPORTED_IMAGE.test(src);
  };

  // Judge.me's CSS sets `display` on these elements, which overrides the `hidden` attribute.
  const hide = (el, hidden) => {
    if (hidden) {
      el.style.setProperty('display', 'none', 'important');
    } else {
      el.style.removeProperty('display');
    }
  };

  const clean = (root) => {
    root.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
      if (isImported(item)) hide(item, true);
    });

    root.querySelectorAll('.jm-media-grid').forEach((grid) => {
      const hasVisible = [...grid.querySelectorAll('.jm-media-grid__item')].some(
        (item) => item.style.display !== 'none'
      );
      hide(grid, !hasVisible);
    });
  };

  const start = () => {
    const widgets = document.querySelectorAll('.jdgm-widget');
    if (!widgets.length) return;

    widgets.forEach((widget) => {
      clean(widget);
      new MutationObserver(() => clean(widget)).observe(widget, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src'],
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
